<template>
    <input @change="previsualizar" name="txtAlbaran" maxlength="40" id="txtAlbaran" tabindex="8" class="text-datos" type="file" style="color:#6F737D;">
</template>

<script>
    export default {
        props: {
            value: Object
        },
        data: () => ({
            archivo: {
                nombre: '',
                base64: ''
            }
        }),

        watch: {
            archivo: {
                deep: true,
                handler(nuevo) {
                    if (nuevo.nombre != '' && nuevo.base64 != '') this.$emit('input', nuevo)
                }
            }
        },

        methods: {
            previsualizar(event) {
                if (event.target.files.length > 0) {
                    event.target.files.forEach(file => this.convertirArchivo(file))
                } else {
                    this.archivo.nombre = ''
                    this.archivo.base64 = ''
                }
            },
            async convertirArchivo(file) {
                if (file != null) {
                    this.archivo.nombre = file.name
                    this.archivo.base64 = await this.convertirBase64(file)
                }
            },
            convertirBase64(file) {
                return new Promise((resolve, reject) => {
                    let reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = () => { resolve(reader.result) }
                    reader.onerror = reject
                })
            }
        }
    }
</script>
